import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { TiThSmall } from 'react-icons/ti';
import { AiFillSetting } from 'react-icons/ai';
import { BsCardChecklist } from 'react-icons/bs';
import { MenuIcon } from './MainMenu.css.js';

const iconImageMap = {
  '/gas': (
    <svg>
      <text x="0" y="20" style={{ border: '1px solid black', fontWeight: 'bold', fontSize: '15px', textAlign: 'center' }}>
        GAS
      </text>
    </svg>
  ),
  '/eventLog': <BsCardChecklist />,
  '/config': <AiFillSetting />,
};

const MenuButton = ({ url, pageName, titleName, subPage, setMainTitle }) => {
  const [view, setView] = useState(false);
  const subPageObj = subPage.map((data, index) => {
    return (
      <li key={data.menu.menuIdx}>
        <NavLink
          exact
          to={data.menu.menuUrl}
          activeClassName="activate"
          isActive={(match, location) => {
            if (
              match ||
              (location.pathname !== '/' && // url이 메인 기본페이지가 아니어야 한다.
                index === 0 && // index 0번은 서브메뉴가 아닌 대메뉴
                url.includes(location.pathname))
            ) {
              setMainTitle(data.menu.titleNm);
              return true;
            }
          }}
        >
          <div>{data.menu.menuNm}</div>
        </NavLink>
      </li>
    );
  });

  return (
    <>
      <MenuIcon
        title={titleName}
        onMouseOver={() => {
          if (subPage.length > 0) setView(true);
        }}
        onMouseLeave={() => {
          if (subPage.length > 0) setView(false);
        }}
        view={subPage.length > 0 && view}
      >
        <NavLink
          exact={url === '/'}
          to={url}
          activeClassName="activate"
          isActive={(match, location) => {
            if (match || (location.pathname === '/' && url === '/')) {
              setMainTitle(titleName);
              return true;
            }
          }}
        >
          {iconImageMap[url]}
        </NavLink>
        <div className="subMenu">
          <ul>{subPageObj}</ul>
        </div>
      </MenuIcon>
    </>
  );
};

export default MenuButton;
